/* tslint:disable */
/* eslint-disable */
/**
 * Berichtsmanagement Generator
 * Generator für AORV-Angebote
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    companyId?: number;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    atMeter: number;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    validFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    validTo?: string;
}

/**
 * Check if a given object implements the Location interface.
 */
export function instanceOfLocation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "atMeter" in value;

    return isInstance;
}

export function LocationFromJSON(json: any): Location {
    return LocationFromJSONTyped(json, false);
}

export function LocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Location {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'name': json['name'],
        'atMeter': json['atMeter'],
        'validFrom': !exists(json, 'validFrom') ? undefined : json['validFrom'],
        'validTo': !exists(json, 'validTo') ? undefined : json['validTo'],
    };
}

export function LocationToJSON(value?: Location | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'companyId': value.companyId,
        'name': value.name,
        'atMeter': value.atMeter,
        'validFrom': value.validFrom,
        'validTo': value.validTo,
    };
}

